import * as React from 'react';
import PropTypes from 'prop-types';

const SvgBadgesMulticolorVerifiedSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FEFEFE"
          d="M23.79 9.713L20.724 7.14l-.696-3.94a.592.592 0 00-.582-.49h-4L12.38.14A.596.596 0 0012 0a.597.597 0 00-.38.14L8.555 2.71H4.553a.592.592 0 00-.582.49l-.694 3.94L.21 9.713a.593.593 0 00-.132.748l2 3.465-.694 3.94a.593.593 0 00.38.659l3.76 1.368 2.001 3.466a.59.59 0 00.714.26l3.76-1.37 3.76 1.37a.595.595 0 00.715-.26l2-3.466 3.76-1.368a.591.591 0 00.38-.659l-.695-3.94 2.001-3.465a.591.591 0 00-.132-.748"
        />
        <path
          fill="#FC4C02"
          d="M22.154 10.011a.51.51 0 01.113.644l-1.718 2.974.597 3.384a.508.508 0 01-.327.566l-3.228 1.174-1.719 2.976a.505.505 0 01-.613.224l-3.23-1.175-3.228 1.175a.505.505 0 01-.614-.224L6.47 18.753 3.24 17.58a.508.508 0 01-.327-.566l.597-3.384-1.72-2.974a.508.508 0 01.115-.644l2.632-2.21.597-3.383a.507.507 0 01.5-.42H9.07l2.633-2.208a.505.505 0 01.652 0l2.633 2.208h3.436c.246 0 .456.177.5.42l.597 3.384 2.632 2.21zM16.07 8.705l-5.52 5.52-2.456-2.458a.856.856 0 00-1.211 1.211l3.062 3.063a.856.856 0 001.211 0l6.125-6.125a.856.856 0 00-1.21-1.211z"
        />
      </g>
    </svg>
  )
);
SvgBadgesMulticolorVerifiedSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgBadgesMulticolorVerifiedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgBadgesMulticolorVerifiedSmall;
